<template>
  <div id="paginationContainer" class="q-py-1" v-if="getProductsCount > 0">
    <p v-if="totalPage !== null && totalPage <= 1 && getProductsCount > 0"
       class="q-fw-normal q-text-secondary q-mb-0 q-text-center q-p-2 ">
      <span v-if="position !=='top'">{{ SmartSearchTranslations.serp.showedAll }}</span>
    </p>
    <div v-else>
      <NextPageButton/>
      <nav aria-label="Serp results navigation">
        <ul class="q-pagination q-justify-content-center q-pe-2">
          <li class="q-page-item q-shadow-sm q-rounded-3 q-go-to-first-button" v-if="page > 0">
            <a class="q-page-link q-px-1" href="#" tabindex="-1" aria-disabled="true"
               @click.prevent="paginationStore.setActualPageValue(0)">{{ '<<' }}</a>
          </li>
          <li class="q-page-item q-shadow-sm q-rounded-3 q-prev-button" v-if="page > 0">
            <a class="q-page-link" href="#" tabindex="-1" aria-disabled="true"
               @click.prevent="paginationStore.setActualPageValue(getPreviousPage)">{{
                prev
              }}</a>
          </li>
          <li class="q-page-item q-shadow-sm q-rounded-3 " v-for="pageNumber in getPages" :key="pageNumber"
              :class="{ 'q-active': pageNumber ===  page + 1 }">
            <a class="q-page-link" href="#"
               :class="{ 'q-active-link': pageNumber ===  page + 1 }"
               @click.prevent="paginationStore.setActualPageValue(pageNumber - 1 )">{{ pageNumber }}</a>
          </li>
          <li class="q-page-item q-shadow-sm q-rounded-3 q-next-button" v-if="page + 1 < totalPage">
            <a class="q-page-link" href="#"
               @click.prevent="paginationStore.setActualPageValue(getNextPage)">{{
                next
              }}</a>
          </li>
        </ul>
      </nav>
    </div>
 <small id="smartSearchVersion">Smart Search by QON version: {{VUE_APP_VERSION}}</small>
  </div>
</template>

<script setup lang="ts">
import {usePaginationStore} from "@/store/SerpPage/PaginationStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";

const serpStore = useSerpResultsStore()
import {storeToRefs} from "pinia";
import {onMounted, defineProps, inject} from "vue";
import {useMobileViewStore} from "@/store/MobileViewStore";

defineProps(['position'])
import {SmartSearchTranslationsInterface} from "@/core/types";
import NextPageButton from "@/components/SerpPage/ResultsContainer/PaginationContainer/NextPageButton.vue";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

let {next, prev} = SmartSearchTranslations.value.pagination
let parser = new DOMParser;
let prevParser = parser.parseFromString('<!doctype html><body>' + prev, 'text/html');
let nextParser = parser.parseFromString('<!doctype html><body>' + next, 'text/html');
prev = prevParser.body.textContent;
next = nextParser.body.textContent;
const { VUE_APP_VERSION } = process.env;

const paginationStore = usePaginationStore();
const {getProductsCount} = storeToRefs(serpStore)

const {
  totalPage,
  page,
  getNextPage,
  getPreviousPage,
  getPages
} = storeToRefs(paginationStore)

onMounted(() => {
  page.value = usePaginationStore().getSelectedPageFromUrl()
  const mobileViewStore = useMobileViewStore()
  window.addEventListener('resize', mobileViewStore.updateIsMobileView);
})

</script>

<style scoped>
#paginationContainer .q-page-link:focus {
  box-shadow: none !important
}

#paginationContainer .q-pagination .q-page-item {
  margin-left: 2px
}

#paginationContainer .q-pagination .q-page-item > .q-page-link:hover {
  color: var(--q-btn-hover-color);
  background-color: var(--q-btn-hover-bg);
  border-color: var(--q-btn-hover-border-color)
}

#paginationContainer .q-pagination .q-page-item > .q-page-link:focus {
  border: 1px solid transparent !important
}

#paginationContainer .q-pagination .q-page-item > .q-page-link {
  color: #333;
  background-color: #fff;
  border: 1px solid transparent !important
}

#paginationContainer .q-pagination .q-page-item.q-active > .q-page-link {
  color: #fff;
  font-weight: 600;
  background-color: #dc3545
}
#smartSearchVersion {
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: 8px;
  color: rgba(0, 0, 0, 0.2);
  user-select: none;
}
</style>
